import { render, staticRenderFns } from "./ZyMainDrag.vue?vue&type=template&id=288b5a2f&scoped=true&"
import script from "./ZyMainDrag.vue?vue&type=script&lang=js&"
export * from "./ZyMainDrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b5a2f",
  null
  
)

export default component.exports